import type { FC } from 'react'
import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import Typography from '@segment/matcha/components/Typography'
import Button from '@segment/matcha/components/Button'

import Section from '@segment/matcha/recipes/Section'

import useScrollToAnchor from '@segment/utils/useScrollToAnchor'

const copy = {
  title: `Get the Customer Engagement Stack in your inbox`,
  description: `Learn about the components of a best-in-class Customer Engagement Stack and be inspired by data-driven customer engagement tactics across every industry.`,
  button: `Download the ebook`,
}
const GetCustomerEngagementStack: FC = () => {
  const theme = useTheme()
  const scrollTo = useScrollToAnchor(`download-the-ebook`)

  return (
    <Section variant="centered">
      <CopyWrapper>
        <Typography variant="h2" tag="h2">
          {copy.title}
        </Typography>
        <Description variant="pLarge" tokens={{ color: theme.palette.twilio.gray[100] }}>
          {copy.description}
        </Description>
        <Button variant="filled" size="large" color="primary" onClick={() => scrollTo()}>
          {copy.button}
        </Button>
      </CopyWrapper>
    </Section>
  )
}

const CopyWrapper = styled.div`
  max-width: 844px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding: 0px 80px;
  }
`

const Description = styled(Typography)`
  margin-top: 0;
`

export default GetCustomerEngagementStack
